import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import "./RechartsOverrides.scss";

const PortfolioAnalyticsChart = ({ data, renderTooltip, tickFormatter, legendUnit }) => {
	const values = data.map(d => d["users"]);
	const downloadValues = data.map(d => d["downloads"]);
	const min = Math.min(...values, ...downloadValues, 0);
	const max = Math.max(...values, ...downloadValues, 1);

	//Generate whole number ticks between min and max
	const ticks = [];
	for (let i = Math.ceil(min); i <= Math.floor(max); i++) {
		ticks.push(i);
	}

	const getInterval = (length, divisor) => {
		if (length <= divisor) return 0; // Show all ticks if data length is less than or equal to divisor
		const interval = Math.floor(length / divisor) - 1
		return interval;
	}

	return (
		<ResponsiveContainer width="100%" height={264}>
			<LineChart data={data} margin={{ top: 8, right: 40, left: 0, bottom: 0 }}>
				<XAxis
					tickLine={false}
					axisLine={false}
					dataKey="name"
					interval={getInterval(data.length, 5)}
					tickFormatter={value => tickFormatter ? tickFormatter(value) : value}
					dy={5}
					tick={{ fontSize: 12 }}
					className="small-axis-label"
				/>
				<YAxis
					axisLine={false}
					tickLine={false}
					ticks={ticks.length > 5 ? null : ticks}
					tick={{ fontSize: 12 }}
					className="small-axis-label"
				/>
				<CartesianGrid vertical={false} strokeDasharray="3 3" />
				<Tooltip content={renderTooltip} />
				<Line type="monotone" dataKey={"downloads"} strokeWidth={2} stroke="#62d9b7" dot={false} name={"Unique Downloaders / " + legendUnit} />
				<Line type="monotone" dataKey={"users"} strokeWidth={2} stroke="#0E8EFD" dot={false} name={"Unique Visitors / " + legendUnit} />
				<Legend align="left" iconType="plainline" wrapperStyle={{ paddingTop: '5px', fontSize: '0.85rem' }} />
			</LineChart>
		</ResponsiveContainer>
	);
}

export default PortfolioAnalyticsChart;